import React from 'react';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import AceEditor from 'react-ace';

// Load ace editor theme and modes
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/mode-css';

export const CustomFunctionEditor = ({
  title,
  icon,
  value,
  mode = 'javascript',
  height = '60vh',
}) => {
  const content = (
    <AceEditor
      mode={mode}
      theme="tomorrow"
      value={value}
      name="custom-function-editor"
      width="100%"
      height={height}
      fontSize={15}
      wrapEnabled={true}
      showPrintMargin={false}
      readOnly={true}
    />
  );

  if (title || icon) {
    return (
      <ParentCardNoCol title={title} icon={icon} bgColor="drapcode-violet">
        {content}
      </ParentCardNoCol>
    );
  }

  return content;
};
